import {
  ACTION_EDIT_PAGE_CONTENT__REQUEST,
  ACTION_EDIT_PAGE_CONTENT__SUCCESS,
  ACTION_EDIT_PAGE_CONTENT__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_PAGE_CONTENT__REQUEST:
    case ACTION_EDIT_PAGE_CONTENT__SUCCESS:
      return null;

    case ACTION_EDIT_PAGE_CONTENT__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
